import Input from './Input.vue';

export default Input;


// WEBPACK FOOTER //
// ./components/Cc-Input/index.js